// Per-tab marker: sessionStorage survives a reload but not a new tab/window.
const LTI_TAB_SESSION_KEY = "libertify:lti-tab-session";

/** Marks the current tab as running a Moodle-launched (LTI) session. */
export const markLtiTabSession = (): void => {
  try {
    sessionStorage.setItem(LTI_TAB_SESSION_KEY, "1");
  } catch {
    // Storage unavailable (private mode, blocked site data) — no marker.
  }
};

/** Whether the current tab was opened by an LTI launch from Moodle. */
export const hasLtiTabSession = (): boolean => {
  try {
    return sessionStorage.getItem(LTI_TAB_SESSION_KEY) === "1";
  } catch {
    return false;
  }
};
